import "./MembershipPlans.scss";

import MembershipPlans from "./MembershipPlans";

export default MembershipPlans;
